import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

// Register required components for the pie chart
ChartJS.register(ArcElement, Tooltip, Legend);
//Re-trigger build
interface Props {
  stockData: { name: string; qty: number }[];
}

const WarehouseStockPieChart: React.FC<Props> = ({ stockData }) => {
  const data = {
    labels: stockData.map((item) => item.name), // Extract item names
    datasets: [
      {
        label: "Warehouse Stock",
        data: stockData.map((item) => item.qty), // Extract quantities
        backgroundColor: [
          "rgba(242, 7, 58, 0.92)",
          "rgba(26, 156, 243, 0.84)",
          "rgba(247, 209, 16, 0.91)",
          "rgba(65, 211, 97, 0.77)",
          "rgba(127, 66, 249, 0.98)",
        ],
        borderColor: [
          "rgba(255, 255, 255, 0.92)",
          "rgba(239, 245, 248, 0.84)",
          "rgb(250, 248, 245)",
          "rgb(240, 243, 243)",
          "rgb(242, 241, 245)", 
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "bottom" as const,
      },
    },
  };

  return (
    <Card sx={{ borderRadius: 1, padding: 2 }}>
    <CardContent>
      <Typography variant="h6" align="center" sx={{ fontWeight: "bold" }}>
        Top 5 Warehouse Stock
      </Typography>
      {stockData.length > 0 ? <Pie data={data} options={options} /> : <p>No data available</p>}
    </CardContent>
  </Card>
  );
};

export default WarehouseStockPieChart;
